import { useEffect, useState } from "react";
import { 
    Avatar, Box, Button, Card, CardActions, CardContent, CardMedia, 
    Container, Grid, IconButton, Tab, Typography, Stack, Divider 
} from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useHistory } from "react-router-dom";
import moment from "moment";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faCalendarDays, faLink, faLocationDot, faTicket, faPlus,
    faDollarSign, faChartLine, faUsers, faShareNodes
} from "@fortawesome/free-solid-svg-icons";

// Componentes QUD
import CustomBreadcrumbs from "../../../components/breadcrumbs";
import QUDProgress from "../../../components/progress";
import ResponseComponent from "../../../components/responseComponent";
import { GetAll } from "../../../controllers/company/EventsController";
import { domain, imagesURL } from "../../../apiRoutes/apiBase";
import { formatStringWithHyphens } from "../../../controllers/AuxController";
import { getEvents } from "../../../controllers/company/events/MerchantEventController";

export default function Events() {
    const currentDate = moment();
    const [value, setValue] = useState('1');
    const history = useHistory();

    const [events, setEvents] = useState([]);
    const [statistics, setStatistics] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [show, setShow] = useState(false);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');

    const redirect = (route) => history.push(route);
    
    useEffect(() => {
        window.scrollTo(0, 0);
        handleGetEvents(1);
    }, []);

    const handleChange = (event, newValue) => setValue(newValue);

    const handleGetEvents = async (status) => {
        setIsLoading(true);
        let {events} = await getEvents(status);
        setEvents(events);
        /*if (response.success === true) {
            setEvents(response.data.events || []);
            setStatistics(response.data.statistics);
        }*/
        setIsLoading(false);
    };

    const handleCopy = (text) => {
        const url = `${domain}eventos/${text}`;
        navigator.clipboard.writeText(url);
        setSuccess(true);
        setMessage('Enlace del evento copiado exitosamente');
        setShow(true);
    };

    // Estilo base para las tarjetas KPI
    const cardStyle = { elevation: 0, sx: { border: '1px solid #e0e0e0', borderRadius: 3, p: { xs: 2, sm: 2.5 }, bgcolor: '#ffffff' } };

    return (
        <Container maxWidth='xl' sx={{ py: { xs: 2, sm: 4 }, mb: 8 }}>
            <CustomBreadcrumbs returnTo='/dashboard' crumbs={[{ name: 'Eventos', link: '/events' }]} />
            
            {/* --- CABECERA PRINCIPAL --- */}
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, mt: 3, mb: 4, gap: 2 }}>
                <Box>
                    <Typography variant="h4" fontWeight={800} sx={{ color: '#222', fontSize: { xs: '1.5rem', sm: '2rem' } }}>
                        Panel de Eventos
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#666', mt: 0.5 }}>
                        Crea, promociona y gestiona la boletería de tus eventos presenciales o virtuales.
                    </Typography>
                </Box>
                
                <Box sx={{ width: { xs: '100%', md: 'auto' } }}>
                   <Button
                        fullWidth
                        variant='contained'
                        color="primary"
                        startIcon={<FontAwesomeIcon icon={faPlus} />}
                        onClick={() => redirect('events/add')}
                        sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3, py: 1 }}
                    >
                        Crear Evento
                    </Button>
                </Box>
            </Box>

            {/* --- CABECERA DE ESTADÍSTICAS (KPIs) --- */}
            {statistics && (
                <Grid container spacing={3} mb={4}>
                    {/* KPI 1: Ganancias 7 días */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Card {...cardStyle}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Avatar variant='rounded' sx={{ width: 44, height: 44, bgcolor: '#e8f5e9', color: '#2e7d32', borderRadius: 2 }}>
                                    <FontAwesomeIcon icon={faDollarSign} size="sm" />
                                </Avatar>
                                <Box flexGrow={1} overflow="hidden">
                                    <Typography variant="caption" sx={{ color: '#888', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Ingresos (7 días)</Typography>
                                    <Typography variant="h6" noWrap sx={{ fontWeight: 700, color: '#222', my: 0.2 }}>
                                        ${parseFloat(statistics.last_week?.ingreso || 0).toFixed(2)}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Card>
                    </Grid>

                    {/* KPI 2: Entradas 7 días */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Card {...cardStyle}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Avatar variant='rounded' sx={{ width: 44, height: 44, bgcolor: '#e3f2fd', color: '#1976d2', borderRadius: 2 }}>
                                    <FontAwesomeIcon icon={faTicket} size="sm" />
                                </Avatar>
                                <Box flexGrow={1} overflow="hidden">
                                    <Typography variant="caption" sx={{ color: '#888', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Entradas (7 días)</Typography>
                                    <Typography variant="h6" noWrap sx={{ fontWeight: 700, color: '#222', my: 0.2 }}>
                                         {parseInt(statistics.last_week?.cantidad || 0)}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Card>
                    </Grid>

                    {/* KPI 3: Ganancias Año */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Card {...cardStyle}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Avatar variant='rounded' sx={{ width: 44, height: 44, bgcolor: '#fff8e1', color: '#ffb300', borderRadius: 2 }}>
                                    <FontAwesomeIcon icon={faChartLine} size="sm" />
                                </Avatar>
                                <Box flexGrow={1} overflow="hidden">
                                    <Typography variant="caption" sx={{ color: '#888', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Ingresos (Año)</Typography>
                                    <Typography variant="h6" noWrap sx={{ fontWeight: 700, color: '#222', my: 0.2 }}>
                                         ${parseFloat(statistics.last_year?.ingreso || 0).toFixed(2)}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Card>
                    </Grid>

                     {/* KPI 4: Entradas Año */}
                     <Grid item xs={12} sm={6} md={3}>
                        <Card {...cardStyle}>
                            <Stack direction="row" spacing={2} alignItems="center">
                                <Avatar variant='rounded' sx={{ width: 44, height: 44, bgcolor: '#f3e5f5', color: '#9c27b0', borderRadius: 2 }}>
                                    <FontAwesomeIcon icon={faUsers} size="sm" />
                                </Avatar>
                                <Box flexGrow={1} overflow="hidden">
                                    <Typography variant="caption" sx={{ color: '#888', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>Entradas (Año)</Typography>
                                    <Typography variant="h6" noWrap sx={{ fontWeight: 700, color: '#222', my: 0.2 }}>
                                          {parseInt(statistics.last_year?.cantidad || 0)}
                                    </Typography>
                                </Box>
                            </Stack>
                        </Card>
                    </Grid>
                </Grid>
            )}

            {/* --- CONTENIDO PRINCIPAL (Tabs y Eventos) --- */}
            <Box>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: '#e0e0e0', mb: 2 }}>
                        <TabList onChange={handleChange} indicatorColor="primary" variant="scrollable" scrollButtons="auto">
                            <Tab 
                                value="1" 
                                onClick={() => handleGetEvents(1)}
                                label={<Typography variant="body2" sx={{ textTransform: 'none', fontWeight: 'bold' }}>Próximos Eventos</Typography>} 
                            />
                            <Tab 
                                value="2" 
                                onClick={() => handleGetEvents(0)}
                                label={<Typography variant="body2" sx={{ textTransform: 'none', fontWeight: 'bold' }}>Eventos Finalizados</Typography>} 
                            />
                        </TabList>
                    </Box>
                    
                    {/* TABS CONTENIDO: PRÓXIMOS EVENTOS */}
                    <TabPanel value={'1'} sx={{ p: 0, pt: 2 }}>
                        <Grid container spacing={3}>
                            {events.length === 0 ? (
                                <Grid item xs={12}>
                                    <Card sx={{ border: '1px solid #e0e0e0', borderRadius: 3, boxShadow: 'none', py: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                                        <Box sx={{ width: 80, height: 80, bgcolor: '#f8f9fa', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 3 }}>
                                            <FontAwesomeIcon icon={faTicket} size="3x" color="#ccc" />
                                        </Box>
                                        <Typography variant="h6" fontWeight={700} sx={{ color: '#333' }} gutterBottom>
                                            No tienes próximos eventos
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#666', maxWidth: 450, mb: 4 }}>
                                            ¡Organiza tu próximo evento, conferencia o taller! Es fácil, rápido y te permite vender entradas directamente.
                                        </Typography>
                                        <Button variant='outlined' color="primary" startIcon={<FontAwesomeIcon icon={faPlus} />} onClick={() => redirect('events/add')} sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
                                            Crear mi primer evento
                                        </Button>
                                    </Card>
                                </Grid>
                            ) : (
                                events.map(event => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={event.id}>
                                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', border: '1px solid #e0e0e0', borderRadius: 3, boxShadow: '0 4px 20px rgba(0,0,0,0.03)', transition: 'transform 0.2s', '&:hover': { transform: 'translateY(-4px)', boxShadow: '0 8px 25px rgba(0,0,0,0.08)' } }}>
                                            {/* Imagen del Evento cubierta completa */}
                                            <CardMedia
                                                component="img"
                                                height="180"
                                                image={`${imagesURL}eventos/${event.image_path}`}
                                                alt={event.name}
                                                sx={{ objectFit: 'cover' }}
                                            />
                                            
                                            <CardContent sx={{ flexGrow: 1, p: 2.5 }}>
                                                <Typography gutterBottom variant="subtitle1" component="div" fontWeight={800} sx={{ lineHeight: 1.2, mb: 2, color: '#222' }}>
                                                    {event.name}
                                                </Typography>
                                                
                                                <Stack spacing={1.5}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: 'text.secondary' }}>
                                                        <FontAwesomeIcon icon={faCalendarDays} style={{ width: 16 }} />
                                                        <Typography variant="body2" fontWeight="500">
                                                            {moment(event.date).format('DD/MM/YYYY')} • {moment(`${currentDate.format('YYYY-MM-DD')} ${event.time}`).format('h:mm A')}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: 'text.secondary' }}>
                                                        <FontAwesomeIcon icon={faLocationDot} style={{ width: 16 }} />
                                                        <Typography variant="body2" fontWeight="500" noWrap>
                                                            {event.city}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                            </CardContent>
                                            
                                            <Divider sx={{ mx: 2 }} />
                                            
                                            <CardActions sx={{ p: 2, justifyContent: 'space-between' }}>
                                                <Box>
                                                    <Button size="small" onClick={() => redirect(`/events/update/${event.id}`)} sx={{ textTransform: 'none', fontWeight: 'bold', color: '#1976d2' }}>
                                                        Editar
                                                    </Button>
                                                    <Button size="small" onClick={() => redirect(`/events/event/${event.id}`)} sx={{ textTransform: 'none', fontWeight: 'bold', color: '#2e7d32' }}>
                                                        Boletería
                                                    </Button>
                                                </Box>
                                                <IconButton size="small" sx={{ bgcolor: '#f0f4f8', color: '#1976d2', '&:hover': { bgcolor: '#e3f2fd' } }} onClick={() => handleCopy(`${event.id}?event=${formatStringWithHyphens(event.name)}`)}>
                                                    <FontAwesomeIcon icon={faLink} size="sm" />
                                                </IconButton>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))
                            )}
                        </Grid>
                    </TabPanel>

                    {/* TABS CONTENIDO: EVENTOS PASADOS */}
                    <TabPanel value={'2'} sx={{ p: 0, pt: 2 }}>
                        <Grid container spacing={3}>
                            {events.length === 0 ? (
                                <Grid item xs={12}>
                                    <Typography variant="body2" color="text.secondary" textAlign="center" py={5}>
                                        No tienes eventos finalizados en tu historial.
                                    </Typography>
                                </Grid>
                            ) : (
                                events.map(event => (
                                    <Grid item xs={12} sm={6} md={4} lg={3} key={event.id}>
                                        {/* Tarjeta de Evento Pasado (Ligeramente opaca para denotar que ya pasó) */}
                                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column', border: '1px solid #e0e0e0', borderRadius: 3, boxShadow: 'none', opacity: 0.8 }}>
                                            <CardMedia component="img" height="160" image={`${imagesURL}eventos/${event.image_path}`} alt={event.name} sx={{ objectFit: 'cover', filter: 'grayscale(30%)' }} />
                                            
                                            <CardContent sx={{ flexGrow: 1, p: 2 }}>
                                                <Typography gutterBottom variant="subtitle2" component="div" fontWeight={800} sx={{ lineHeight: 1.2, mb: 1, color: '#555' }}>
                                                    {event.name}
                                                </Typography>
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'text.secondary', mb: 0.5 }}>
                                                    <FontAwesomeIcon icon={faCalendarDays} style={{ width: 14 }} />
                                                    <Typography variant="caption" fontWeight="500">
                                                        {moment(event.date).format('DD/MM/YYYY')}
                                                    </Typography>
                                                </Box>
                                            </CardContent>
                                            <Divider sx={{ mx: 2 }} />
                                            <CardActions sx={{ p: 1.5, justifyContent: 'center' }}>
                                                <Button size="small" onClick={() => redirect(`/events/tickets/${event.id}`)} sx={{ textTransform: 'none', fontWeight: 'bold', color: '#666' }}>
                                                    Ver Reporte (Boletería)
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                ))
                            )}
                        </Grid>
                    </TabPanel>
                </TabContext>
            </Box>

            <QUDProgress open={isLoading} />
            <ResponseComponent
                show={show}
                success={success}
                message={message}
                actionText='Finalizar'
                onClick={() => setShow(false)}
            />
        </Container>
    );
}